export function getDataForPublishing() {
  const values = {};

  values["fr"] = document.getElementById("fr").checked ? "1" : "0";
  values["frill"] = document.getElementById("frill").checked ? "1" : "0";
  values["isro"] = document.getElementById("isro").checked ? "1" : "0";
  values["frsz"] = document.getElementById("frsz").checked ? "1" : "0";
  values["a"] = document.getElementById("a").checked ? "1" : "0";

  values["pair"] = document.getElementById("pair").checked ? "1" : "0";

  values['designType'] = document.getElementById("design-type").value; // prettier-ignore
  values["designNumber"] = document.getElementById("design-number").value;
  
  values["dessinnr"] = document.getElementById("l-no").value;
  values["paarnr"] = document.getElementById("r-no").value;
  values["exnr"] = document.getElementById("ex-no").value;
  values["entwerfer_uid"] =
    document.getElementById("designer").getAttribute("data-id") ||
    document.getElementById("designer").value; // prettier-ignore
  values["zeichner_uid"] =
    document.getElementById("drawer").getAttribute("data-id") ||
    document.getElementById("drawer").value; // prettier-ignore
  values["puncher_uid"] =
    document.getElementById("puncher").getAttribute("data-id") ||
    document.getElementById("puncher").value; // prettier-ignore
  values['collectionId'] =
    document.getElementById("collection").getAttribute("data-id") ||
    document.getElementById("collection").value; // prettier-ignore
  values["thema_id"] =
    document.getElementById("theme").getAttribute("data-id") ||
    document.getElementById("theme").value; // prettier-ignore
  values["artikel_id"] =
    document.getElementById("article").getAttribute("data-id") ||
    document.getElementById("article").value; // prettier-ignore
  values["serie_id"] =
    document.getElementById("series").getAttribute("data-id") ||
    document.getElementById("series").value; // prettier-ignore
  [values["kleinster_rapport"], values["groesster_rapport"]] = getSmallestAndLargestRepeat(); // prettier-ignore
  values["bohren_blind"] = document.getElementById("boring").checked
    ? "1"
    : "0";
  values["spachteln"] = document.getElementById("cutting-work").checked
    ? "1"
    : "0"; // prettier-ignore
  values["infobrett"] = document.getElementById("comment").value;
  values["wechselfarbig"] = document.getElementById("alternating-color").checked
    ? "1"
    : "0"; // prettier-ignore
  values["provnr"] = document.getElementById("temp-no").value;
  values["wunschbreite"] = document.getElementById("target-width").value;
  values["stickhoehe_gez"] = document.getElementById("drawn-width").value;
  values["einteilbreite_ungestr"] =
    document.getElementById("unstretched-width").value;
  values["stretchPercent"] = document.getElementById("stretch-percent").value;
  values["stretchedWidth"] = document.getElementById("stretched-width").value;
  values["stitches"] = document.getElementById("stitches").value;
  values["print"] = document.getElementById("print").value;
  values["laser"] = document.getElementById("laser").checked ? "1" : "0"; // prettier-ignore;
  values["bluecut"] = document.getElementById("bluecut").checked ? "1" : "0"; // prettier-ignore;
  values["thermocut"] = document.getElementById("thermocut").checked
    ? "1"
    : "0";
  values["l_r"] = document.getElementById("L-R").checked ? "1" : "0";
  values["stichlimit"] = document.getElementById("stitch-limit").value;
  values["berechnung_stichzahl"] =
    document.getElementById("stitch-limit").value;
  values["berechnung_uid"] =
    document.getElementById("estimated").getAttribute("data-id") ||
    document.getElementById("estimated").value;
  values["discussed"] =
    document.getElementById("discussed").getAttribute("data-id") ||
    document.getElementById("discussed").value;
  values["auswahldatum"] = document.getElementById("date").value;
  values["frill_number"] = document.getElementById("fril-no").value;

  // New logic for cut-app-f and cut-app-b checkboxes
  const cutAppFChecked = document.getElementById("cut-app-f").checked;
  const cutAppBChecked = document.getElementById("cut-app-b").checked;
  
  // Set abdecken to 1 if at least one of the checkboxes ('cut-app-f' or 'cut-app-b') is checked,
  // otherwise set abdecken to 0. This means if either or both are checked, abdecken will be 1; 
  // only if neither is checked will abdecken be 0.

  values["abdecken"] = (cutAppFChecked || cutAppBChecked) ? 1 : 0;


  // Set the values for cut-app-f and cut-app-b too
  values["cut_app_f"] = cutAppFChecked ? "1" : "0";
  values["cut_app_b"] = cutAppBChecked ? "1" : "0";
  
  // Get all the input fields for 'No' values in the #yarn-container
  let yarnNumbers = document.querySelectorAll("#yarn-container input.custom-number");

  // Create a Set to store unique values before the decimal point
  let uniqueNumbers = new Set();

  yarnNumbers.forEach(input => {
    let value = input.value;
    
    // Split the value at the dot and take the part before the dot
    let numberBeforeDot = value.split('.')[0];
    
    // Add to the Set (Sets only store unique values)
    uniqueNumbers.add(numberBeforeDot);
  });

  // The number of unique values before the decimal point
  let uniqueCount = uniqueNumbers.size;

  values["anzahl_farben"] = uniqueCount;

  // Added plain fabric top and bottom for saving
  values["top"] = document.getElementById("top").value;
  values["bottom"] = document.getElementById("bottom").value;

  values["yarnIds"] = getYarnIds();
  values["fabricIds"] = getFabricIds();
  // remove modal
  document.querySelector(".modal")?.parentElement.remove();
  return values;
}

function getFabricIds() {
  const fabricContainer = document.querySelector(
    ".editor-content__form .fabric"
  );
  const fabricContainerChildren = fabricContainer.querySelectorAll("input");
  const values = [];
  let pos = 1;
  for (let i = 0; i < fabricContainerChildren.length; i += 5) {
    if (fabricContainerChildren[i].value === "") continue;
    const fabricData = {};
    fabricData["stoff_id"] =
      fabricContainerChildren[i + 2].getAttribute("data-id") ||
      fabricContainerChildren[i + 2].value;
    fabricData["lagecode_id"] =
      fabricContainerChildren[i + 1].getAttribute("data-id") ||
      fabricContainerChildren[i + 1].value;
    fabricData["arbeitsschritt"] = fabricContainerChildren[i].value;
    fabricData["pos"] = pos;
    fabricData["dessinvari"] = 1;
    values.push(fabricData);
    pos++;
  }
  return values;
}

function getYarnIds() {
  // Process yarn container
  const yarnContainer = document.querySelector("#yarn-container");
  const yarnContainerChildren = yarnContainer.querySelectorAll("input");
  const values = [];

  for (let i = 0; i < yarnContainerChildren.length; i += 5) {

    if (yarnContainerChildren[i].value === "") continue;
    const yarnData = {};
    yarnData["garn_id"] =
      yarnContainerChildren[i].getAttribute("data-id") ||
      yarnContainerChildren[i].value;
    yarnData["pos"] = yarnContainerChildren[i+2].value ? yarnContainerChildren[i+2].value : 0;
    yarnData["dessinvari"] = 1;
    values.push(yarnData);
  }

  // Process sequins container
  const sequinsContainer = document.querySelector("#sequins-container");
  const sequinsContainerChildren = sequinsContainer.querySelectorAll("input");

  for (let i = 0; i < sequinsContainerChildren.length; i += 4) {
    if (sequinsContainerChildren[i].value === "") continue;
    const sequinsData = {};
    sequinsData["garn_id"] =
      sequinsContainerChildren[i].getAttribute("data-id") ||
      sequinsContainerChildren[i].value;
    sequinsData["pos"] = sequinsContainerChildren[i+2].value ? sequinsContainerChildren[i+2].value : 0;
    sequinsData["dessinvari"] = 1;
    values.push(sequinsData);
  }

  return values;
}

function getSmallestAndLargestRepeat() {
  const repeats = document.querySelectorAll(".repeat");
  const repeatValues = [];

  for (let i = 0; i < repeats.length; i++) {
    const value = parseInt(repeats[i].value, 10); // Convert to an integer
    if (!isNaN(value)) { // Check if the value is a valid number
      repeatValues.push(value);
    }
  }

  if (repeatValues.length === 0) {
    return [null, null]; // Handle the case where there are no valid repeat values
  }

  // If only one valid value exists, return 0 as the smallest value
  if (repeatValues.length === 1) {
    return [0, repeatValues[0]];
  }

  return [Math.min(...repeatValues), Math.max(...repeatValues)];
}
